module.exports = __webpack_public_path__ + "img/women-logo.2c19f5b5.png";